import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';


const T = Translator.create();

export function getValidation(props?: IValidation) {

    const defaultValidation = new DefaultValidation(props);

    if (props && props.isProjectSubActivity) {
        return Yup.object().shape({ name: defaultValidation.GetName() });
    }
    return Yup.object().shape({
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        isFileUploadEmpty: defaultValidation.GetIsFileUploadEmpty(),
        name: defaultValidation.GetName(),
        description: Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .required(T.t('r_field_required')),
        activityBeginDate: defaultValidation.GetActivityBeginDate(),
        activityBeginTime: defaultValidation.GetActivityBeginTime(),
        activityEndDate: defaultValidation.GetActivityEndDate(),
        activityEndTime: defaultValidation.GetActivityEndTime(),
        datePrerequisiteActivityId: defaultValidation.GetDatePrerequisiteActivityId(),
        isCommon: defaultValidation.GetIsCommon(),
        selectedClass: defaultValidation.GetSelectedClass(),
        activityTime: defaultValidation.GetActivityTime(),
        fileUploaded: Yup.bool(),
        prerequisiteActivityId: defaultValidation.GetPrerequisiteActivityId(),
    });
}
